import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../common/html/element'
import SideBarUserManagement from '../SideBarUserManagement'
import { Title } from '../Title'
import classes from '../index.module.scss'
import '../lang/i18n'
import { FormEditProfile } from './form/FormEditProfile'
import classes2 from './index.module.scss'
import { selectLoadingUserProfile, selectUserProfile } from './store/slice'
import { getJobTitles, getUserProfile } from './store/thunk'

export const UserProfile = () => {
  const dispatch = useDispatch()

  const isLoadingUserProfile = useSelector(selectLoadingUserProfile)
  const userProfile = useSelector(selectUserProfile)
  const locale = useSelector((state) => state.i18n.locale)

  useEffect(() => {
    dispatch(getUserProfile())
  }, [])

  useEffect(() => {
    dispatch(getJobTitles())
  }, [locale])

  const renderBottomComponent = () => {
    return (
      <div className={classes2.container}>
        <div style={{ border: '1px solid #EBEBEB' }}>
          <div className={classes.userProfileContent}>
            <Element
              className={classes.editProfileTitle}
              style={{ fontSize: 20 }}
            >
              <Translate value="userProfile.EDIT_PROFILE" />
            </Element>
            <FormEditProfile />
          </div>
        </div>
        <Element style={{ border: '1px solid #EBEBEB', marginTop: 12 }}>
          <div className={classes.changePasswordContent}>
            <Element
              className={classes.editProfileTitle}
              style={{ fontSize: 20 }}
            >
              <Translate value="userProfile.CHANGE_PASSWORD" />
            </Element>
            <Element className={classes.inforText}>
              <Translate value="userProfile.CLICK" />
              <a
                style={{ color: '#2C73E8', cursor: 'pointer' }}
                href={[
                  process.env.REACT_APP_AUTHORITY_URL,
                  '/account/changepassword',
                  `?email=${userProfile?.companyEmail}&clientId=${process.env.REACT_APP_CLIENT_ID}`,
                ].join('')}
              >
                <Translate value="userProfile.HERE" />
              </a>
              <Translate value="userProfile.TO_CHANGE" />
            </Element>
          </div>
        </Element>
      </div>
    )
  }

  return (
    <SideBarUserManagement
      renderTopComponent={() => <Title text="userProfile.USER_PROFILE" />}
      renderBottomComponent={renderBottomComponent}
      isLoadingContent={isLoadingUserProfile}
    />
  )
}
